export const BaseUrl = "https://api.doxandbox.com/"

export const getAssetUrl = (path) => {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return `${BaseUrl}${String(path).replace(/^\/+/, "")}`;
};
 
